import { AddressSearchExample } from "../../../../../../packages/design-system/src/AddressSearch/readme-helpers";
import * as React from 'react';
export default {
  AddressSearchExample,
  React
};